export default {
    state: {
        deudores: [],
        obligaciones: [],
        historico_gestion: [],
        acuerdos_pago: [],
    },
    getters: {
        deudor: state => state.deudores[0] || {},
        obligaciones: state => state.obligaciones,
        historico_gestion: state => state.historico_gestion,
        acuerdos_pago: state => state.acuerdos_pago,
    },
    mutations: {
        SET_DEUDORES: (state, payload) => state.deudores = payload,
        SET_OBLIGACIONES: (state, payload) => state.obligaciones = payload,
        SET_HISTORICO_GESTION: (state, payload) => state.historico_gestion = payload,
        SET_ACUERDOS_PAGO: (state, payload) => state.acuerdos_pago = payload,
        SET_ACUERDO_PAGO: (state, payload) => {
            const index = state.acuerdos_pago.findIndex(item => item.id === payload.id);
            if (index !== -1) {
                state.acuerdos_pago.splice(index, 1, payload);
            }
        },
        /*[SOCKET_PROCESO]: (state, payload) => {
            const index = state.acuerdos_pago.findIndex(item => item.id === payload.id);
            if (index !== -1) {
                state.acuerdos_pago.splice(index, 1, payload);
            } else {
                state.acuerdos_pago.push(payload);
            }
        },*/
    },
    actions: {
        refresh_deudores({commit}, payload) {
            commit('SET_DEUDORES', payload)
        },
        refresh_obligaciones({commit}, payload) {
            commit('SET_OBLIGACIONES', payload)
        },
        refresh_historico_gestion({commit}, payload) {
            commit('SET_HISTORICO_GESTION', payload)
        },
        refresh_acuerdos_pago({commit}, payload) {
            commit('SET_ACUERDOS_PAGO', payload)
        }
    }
}